module.exports = __webpack_public_path__ + "aa928bd029d07c272874d437012fcd47.png";